import React from "react";
import { TextField, Box } from "@mui/material";

const LargeTextField = ({ label, value, onChange, disabled = false, minRows = 3, backgroundColor }) => {
  return (
    <Box sx={{ marginBottom: "20px" }}>
      <Box sx={{
        fontSize: "14px",
        fontWeight: 600,
        color: "#1A1E24",
        marginBottom: "8px"
      }}>
        {label}
      </Box>
      <TextField
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        multiline
        minRows={minRows}
        fullWidth
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            fontSize: "14px",
            backgroundColor: backgroundColor || "transparent",
            "& fieldset": {
              borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
              borderColor: "#1976d2",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1976d2",
            },
          },
        }}
      />
    </Box>
  );
};

export default LargeTextField;
